import { ConversionOutputStreamDestination } from './destination-list';

/** Write-only fields of each destination, masked on read. */
export const outputStreamDestinationSensitiveFields: Record<
  ConversionOutputStreamDestination,
  string[]
> = {
  email: [],
  webhook: [],
  'meta-ads': ['accessToken'],
  'google-ads-data-manager': [],
  'microsoft-ads-conversion': [],
  'openai-ads': ['apiKey'],
};

export function getSensitiveFieldsForDestination(
  destinationName: string,
): string[] {
  return (
    outputStreamDestinationSensitiveFields[
      destinationName as ConversionOutputStreamDestination
    ] ?? []
  );
}
